// extracted by mini-css-extract-plugin
export default {"environment":"Environment_environment__9KX91"};